export const ROLES = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  BENEFICIARY: 'BENEFICIARY',
  SPONSOR: 'SPONSOR',
}
